import { Button } from "../ui/button";
import { useModal } from "@/hooks/useModal";
import { LogoutModal } from "../Modals/LogoutModal";


export function LogoutSection() {
  const { openModal } = useModal();

    const handleLogout = () => {
      openModal(<LogoutModal />);
    };
  
    return (
      <div>
        <h1 className="text-2xl font-bold text-blue-dark mb-4">Logout</h1>
        <Button variant='wallet-btn' size='walletBtn' className="bg-red-500 text-white"
            onClick={() => handleLogout()}>
            Logout
        </Button>
      </div>
    );
  }